var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUgraLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294,
    height: 292,
    viewBox: "0 0 294 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.8127 226.929C44.1501 205.32 32.2001 176.57 32.1626 145.974C32.0918 88.2743 74.9252 40.3784 130.484 32.4575L130.442 0.0450211C57.1002 8.17419 -0.0915567 70.5576 0.000110037 146.012C0.0501101 185.199 15.3543 222.02 43.1001 249.699C67.0085 273.549 97.6919 288.12 130.8 291.666L130.763 259.266C106.263 255.87 83.6293 244.704 65.8127 226.929Z",
    fill: "#8BCD39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M293.417 145.65C293.325 70.1876 235.975 7.94167 162.6 0L162.642 32.4167C218.225 40.1917 261.184 87.9876 261.254 145.692C261.325 203.392 218.488 251.296 162.925 259.209L162.963 291.621C236.309 283.496 293.509 221.109 293.417 145.65Z",
    fill: "#8BCD39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.779 140.446L130.634 140.483L130.717 224.966L162.875 224.929H162.879L162.792 140.446H162.779Z",
    fill: "#8BCD39"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M203.404 83.6542H90.0085V115.817H203.404V83.6542Z",
    fill: "#8BCD39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUgraLogo);
export default __webpack_public_path__ + "static/media/ugraLogo.e19c5c1fbf28d546e5286260e54d1c0d.svg";
export { ForwardRef as ReactComponent };